import { useNotifierAction } from "@lib/notification";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { LoadingButton as Button } from "@mui/lab";
import { Box, TextField, Typography } from "@mui/material";
import trim from "lodash/trim";
import { useRouter } from "next/router";
import * as React from "react";
import { subscribeBlog } from "services/blog";

export default function Subscribe({}): React.ReactElement {
  const [email, setEmail] = React.useState("");
  const [isCheck, setCheck] = React.useState(false);
  const [isSuccess, setSuccess] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const { enqueueSnackbar } = useNotifierAction();
  const router = useRouter();

  const handleSubscribe = (ev) => {
    ev.preventDefault();
    const value = trim(email);
    if (value === "" || !isCheck) {
      return;
    }
    setLoading(true);
    subscribeBlog({
      email: value,
      from: router.asPath || null,
    })
      .then((res) => {
        setLoading(false);
        if (res && res.success) {
          setSuccess(true);
          return;
        }
        enqueueSnackbar({
          message: "Fail to subscribe.",
          options: {
            key: new Date().getTime() + Math.random(),
            variant: "error",
          },
        });
      })
      .catch((err) => {
        setLoading(false);
        enqueueSnackbar({
          message: "Fail to subscribe.",
          options: {
            key: new Date().getTime() + Math.random(),
            variant: "error",
          },
        });
      });
  };

  return (
    <Box>
      <Typography variant="subtitle1">Subscribe to new blog posts</Typography>
      <Box sx={{ position: "relative" }}>
        {isSuccess && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "white",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckCircleOutlineRoundedIcon
              color="primary"
              fontSize="large"
              sx={{ mb: 1 }}
            />
            <Typography
              variant="body2"
              align="center"
              sx={{ display: "flex", alignItems: "center" }}
            >
              Sit back and relax, your journey with us has just begun.
            </Typography>
          </Box>
        )}
        <form onSubmit={handleSubscribe}>
          <Box sx={{ my: 2 }}>
            <TextField
              placeholder="Enter your email"
              fullWidth
              size="small"
              value={email}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </Box>
          <Button
            size="large"
            variant="contained"
            startIcon={<EmailRoundedIcon />}
            fullWidth
            type="submit"
            loading={isLoading}
          >
            Subscribe
          </Button>
        </form>
        <Box
          sx={{
            mt: 2,
            display: "flex",
          }}
        >
          <Box>
            <input
              id="sidebar-policy-checkbox"
              type="checkbox"
              checked={isCheck}
              onChange={(ev) => setCheck(ev.target.checked)}
              className="accent-primary-main hover:accent-primary-dark"
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              pl: 1,
              fontSize: 13,
            }}
          >
            I agree to my data being processed in accordance with{" "}
            <a
              href="https://www.printy6.com/page/privacy-policy/"
              target="_blank"
            >
              Printy6's Privacy Policy
            </a>{" "}
            and to receive blog news. Unsubscribe at any time.
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
